import clsx from 'clsx';
import { SearchBarProps } from './types';

const SearchBar: React.FC<SearchBarProps> = ({ children, size = 'sm', showShadow = false, className }) => {
  return (
    <div
      className={clsx(
        'relative flex w-full flex-col items-center gap-3 lg:flex-row lg:gap-0 lg:rounded-full lg:bg-neutral-active',
        size === 'sm' && 'lg:h-11',
        size === 'lg' && 'lg:h-[60px]',
        showShadow && 'lg:shadow-[0_10px_30px_rgba(6,29,79,0.08)]',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default SearchBar;
